export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isHandling: (state) => state.isHandling,
  detail: (state) => state.detail,
  questionnaire: (state) => state.questionnaire,
};
